(() => {
  'use strict';

  const POLAROID_IMAGE =
    'variant-king-combined-listing .swatches-type-products [data-slider-data*="polaroid-swatch"] .star-set-image';

  function centreImage(image) {
    const current = image.style.backgroundImage;

    if (current) {
      const centred = current.replace(/([?&])crop=top(?=([&)"']|$))/gi, '$1crop=center');
      if (centred !== current) image.style.backgroundImage = centred;
    }

    if (image.style.getPropertyValue('background-position') !== 'center center') {
      image.style.setProperty('background-position', 'center center', 'important');
    }
  }

  function scan(root = document) {
    if (root.nodeType === Node.ELEMENT_NODE && root.matches?.(POLAROID_IMAGE)) {
      centreImage(root);
    }

    root.querySelectorAll?.(POLAROID_IMAGE).forEach(centreImage);
  }

  scan();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        if (mutation.target.matches?.(POLAROID_IMAGE)) centreImage(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(scan);
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style'],
  });

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
